import { Trans, useTranslation } from 'react-i18next';
import { C } from '../ChatAssistant/compact/tokens';
import { font as f } from '../ChatAssistant/compact/style';
import { Icon } from '../ChatAssistant/compact/kit';
import { SUPPORT_TELEGRAM_URL } from './model';
import { Modal, ModalFoot, ModalHead, PrimaryBtn, TextBtn } from './ui';

/* Wallet terms — what happens to money once it's in the wallet. Opened from the wallet
   card in the Payments header and from the Top up dialog. */

const POINTS = [
  { key: 'noRefund', icon: 'lock' },
  { key: 'support', icon: 'send' },
] as const;

export function WalletTermsDialog({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation('paymentsCompact');
  const link = <a href={SUPPORT_TELEGRAM_URL} target="_blank" rel="noreferrer" style={{ color: C.purpleLt, fontWeight: 500 }} />;
  return (
    <Modal width={460} onClose={onClose}>
      <ModalHead icon="shield" title={t('terms.title')} onClose={onClose} />
      <div style={{ padding: '6px 16px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {POINTS.map((p) => (
          <div key={p.key} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <span style={{ width: 28, height: 28, flex: 'none', borderRadius: 7, background: C.tint16, color: C.purpleLt, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Icon name={p.icon} size={14} />
            </span>
            <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
              <span style={{ font: f(600, 13), color: C.text }}>{t(`terms.${p.key}.title`)}</span>
              <span style={{ font: f(400, 12.5, 1.5), color: C.sub }}>
                <Trans t={t} i18nKey={`terms.${p.key}.body`} components={{ a: link }} />
              </span>
            </span>
          </div>
        ))}
      </div>
      <ModalFoot>
        <span style={{ flex: 1 }} />
        <TextBtn onClick={onClose}>{t('close')}</TextBtn>
        <PrimaryBtn icon="send" height={30} onClick={() => window.open(SUPPORT_TELEGRAM_URL, '_blank', 'noreferrer')} style={{ font: f(600, 12.5), padding: '0 14px' }}>
          {t('terms.contact')}
        </PrimaryBtn>
      </ModalFoot>
    </Modal>
  );
}
